import React, { useState, useEffect } from "react";
import InputField from "./InputField";
import SuggestionsList from "./SuggestionsList";
import ItemDisplay from "./ItemDisplay";
import css from "./AutoSamplete.module.css";
import { SERVER_URL } from "../../config";

function AutoSamplete({ contract, setContract }) {
  const [textInput, setTextInput] = useState("");
  const [results, setResults] = useState([]);

  const [fieldName, setFieldName] = useState("");
  //use state to define which route to fetch to, set this with dropdown menu
  //   const [route, setRoute] = useState("");

  //click an autocomplete option to set searchfield to that option
  //   function handleClick(option) {
  //     setTextInput(option);
  //   }

  async function getSpecificContract(id) {
    const res = await fetch(`${SERVER_URL}/contracts/${id}`);
    const data = await res.json();
    setContract(data.payload);
  }

  console.log(textInput);
  console.log(contract);

  function handleTextInput(event) {
    setTextInput(event.target.value);
    setResults([]);
  }

  useEffect(() => {
    fetch(`${SERVER_URL}/contracts?search=${textInput}`)
      .then(res => res.json())
      .then(({ payload }) => setResults(payload));
  }, [textInput]);

  function handleChange(e) {
    const { value } = e.target;
    setFieldName(value);
  }

  return (
    <div className={css.autosampletecontainer}>
      <select className={css.dropdown} onChange={handleChange}>
        <option className={css.dropdown1}>Contract</option>
        <option className={css.dropdown2}>Subject</option>
        <option className={css.dropdown3}>Provider</option>
        <option className={css.dropdown4}>Main Contacts</option>
      </select>
      <InputField textInput={textInput} handleTextInput={handleTextInput} />
      {textInput && (
        <SuggestionsList
          setTextInput={setTextInput}
          results={results}
          getSpecificContract={getSpecificContract}
        />
      )}
    </div>
  );
}

export default AutoSamplete;
